import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { Col, Container, Row, Image } from "react-bootstrap";
export default function AboutNakamotoThreshold() {
  const $ = _c(57);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Row><Col><h1>Nakamoto Threshold</h1></Col></Row>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="font-larger font-bolder">What is the Nakamoto Threshold?</p>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p>This is a bit of Memes inside-baseball but I am{" "}<Link href="https://x.com/punk6529/status/1779105411443949809" target="_blank" rel="noopener noreferrer">tweeting</Link>{" "}it out so we have it available for reference.</p>;
    t3 = <p>Meme Card #4 is an homage to the first Rare Pepe which had an edition count of 300.</p>;
    t4 = <p>So Meme Card #4 had an edition count of 300.</p>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Image loading="eager" width="0" height="0" style={{
      height: "auto",
      width: "auto",
      maxHeight: "400px",
      maxWidth: "100%",
      margin: "2vw"
    }} src="/the-memes-4.jpeg" alt="6529 Gradient" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Row className="pt-2"><Col>{t1}{t2}{t3}{t4}<p>{t5}<Image loading="eager" width="0" height="0" style={{
            height: "auto",
            width: "auto",
            maxHeight: "400px",
            maxWidth: "100%",
            margin: "2vw"
          }} src="/nakamoto-card-og.png" alt="6529 Gradient" /></p></Col></Row>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Row className="pt-3"><Col><p className="font-larger font-bolder">Edition Sizes Matter</p><p>The Memes were deliberately designed to be relatively low unit price and relatively high edition count.</p><p>This is important for the overall mission in a large numbers of ways. There is no way the mission works with a small number of rich collectors.</p><p>Interestingly, because people like eye-catching sales, this is one of the things that leads people to still underestimate The Memes a bit.</p><p>{"The Naka has the highest unit price because it is an awesome card (trades around 6ETH now, ATH > 20ETH) but..."}</p></Col></Row>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Row className="pt-3"><Col><p>...if the mission was "maximize unit price", we could have easily dropped some ed: 50 and ed: 10 and ed: 5 and 3 and 2 and 1 and some of those would have traded at higher unit prices.</p><p>But not only that does not help what we are trying to do here, it hurts it.</p></Col></Row>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Row className="pt-3"><Col><p>OK, remind me of the mission?</p><p>Not today. But soon. This is a thread about the Nakamoto Threshold.</p><p>So early on, I said Card #4 would be the lowest edition card.</p><p>Seemed like a nice homage to the OG Naka, an appropriate level of respect where respect was due.</p></Col></Row>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Row className="pt-3"><Col><p>To be honest, back then it did not even seem like a hard decision.</p><p>I knew we would lose some marketing value by not having high unit price sales from small editions, but ok, whatever.</p><p>Edition sizes were 500, 1,000, 2,000.</p><p>Seemed like a safe hurdle.</p><p>The Nakamoto Threshold: all others will exceed 300 </p></Col></Row>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Row className="pt-3"><Col><p className="font-larger font-bolder">Testing the Threshold</p><p>Bear market came.</p><p>Instead of people yelling me for being "elitist" for only have edition sizes of 1K to 2K and not expanding (seriously, this was a thing for like 3 months), people started disappearing.</p></Col></Row>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Row className="pt-3"><Col><p>We roughly try to match edition sizes to demand.</p><p>It is art, not science. Demand is not so predictable and, of course, the actual art and actual artist makes a big difference.</p><p>Some artists would sell out any edition size instantly.</p></Col></Row>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Row className="pt-3"><Col><p>So we try to find a happy medium between the well-known artists and the less well-known artists and that means the edition sizes started grinding down.</p><p>For a few months, they have been averaging in the low three hundreds.</p></Col></Row>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Row className="pt-3"><Col><p>Now, low three hundreds for art editions, three times a week, across many artists, in an NFT bear markets isn't "good", it is "awesome"</p><p>More individual pieces of art are minted on The Memes each week than almost anywhere else in the NFT space.</p></Col></Row>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Row className="pt-3"><Col><p>Let's say, depending on the artist and how the crypto world feels that day, a meme card would mint out between 275 to 350 on average right now (exceptions exist on both sides).</p><p>Is this a problem? It is not a problem at all. It is great, awesome!</p></Col></Row>;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Row className="pt-3"><Col><p>And, in USD terms, we are not at the bottom.</p><p>ETH is expensive again now, so, in USD terms, the mints are fine.</p></Col></Row>;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Row className="pt-3"><Col><p className="font-larger font-bolder">Consider the Options</p><p>If 2 years ago I had not said "Card 4 will be the lowest edition count", we would not even be thinking about this at all.</p></Col></Row>;
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  let t18;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Row className="pt-3"><Col><p>But I did say that, I said that Card 4 would be the lowest edition count so, a few months ago, we hit Decision Time™</p><p>It was clear some cards would not hit 300 mints.</p><p>What should we do?</p></Col></Row>;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  let t19;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Row className="pt-3"><Col><p>There was *a lot* of discussion in Discord and basically it boiled down to 5 ideas:</p><p><ol><li>Change the threshold</li><li>Mint fewer times per week</li><li>Airdrop to collectors</li><li>I mint them</li><li>Airdrop somewhere else</li></ol></p></Col></Row>;
    $[19] = t19;
  } else {
    t19 = $[19];
  }
  let t20;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Row className="pt-3"><Col><p>The first one was the easiest.</p><p>"Sure, I said that, but circumstances change, we have to change with circumstances. Empires rise and fall, major companies go bankrupt, the only sure thing is the heat death of the universe. It can't be that this is the one immutable"</p></Col></Row>;
    $[20] = t20;
  } else {
    t20 = $[20];
  }
  let t21;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Row className="pt-3"><Col><p>I gave this option serious consideration because I do think, in many things, people should be flexible and adapt to circumstances.</p><p>Ultimately, I decided against it for two reasons</p><p>First of all, I like to do what I say I am going to do if there is any way possible to do it</p></Col></Row>;
    $[21] = t21;
  } else {
    t21 = $[21];
  }
  let t22;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Row className="pt-3"><Col><p>And I could see a way to do it. It would be costly to me, but I made up the rule in the first place, it is OK if I had to pay a price for it.</p><p>The second is more subtle.</p><p>Even in crypto many things change. The BTC of today is not the BTC of Satoshi. Same with Ethereum.</p></Col></Row>;
    $[22] = t22;
  } else {
    t22 = $[22];
  }
  let t23;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Row className="pt-3"><Col><p>But it is important that something stays fixed</p><p>In BTC it is easy, it is 21M BTC.</p><p>BTC will live or die based on the 21M issuance schedule never changing.</p><p>It is the bright line that distinguishes BTC from not-BTC.</p></Col></Row>;
    $[23] = t23;
  } else {
    t23 = $[23];
  }
  let t24;
  let t25;
  let t26;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <p>Ethereum faced an important decision of this nature in 2016.</p>;
    t25 = <p>There is a fork (less important now) from the early days (Ethereum vs Ethereum Classic) about whether Ethereum should have reorged out The DAO attacker.</p>;
    t26 = <p>History lesson below.</p>;
    $[24] = t24;
    $[25] = t25;
    $[26] = t26;
  } else {
    t24 = $[24];
    t25 = $[25];
    t26 = $[26];
  }
  let t27;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Row className="pt-3"><Col>{t24}{t25}{t26}<p><Image loading="eager" width="0" height="0" style={{
            height: "auto",
            width: "auto",
            maxHeight: "400px",
            maxWidth: "100%",
            margin: "2vw"
          }} src="/ethereum-history.png" alt="6529 Gradient" /></p></Col></Row>;
    $[27] = t27;
  } else {
    t27 = $[27];
  }
  let t28;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <Row className="pt-3"><Col><p>So back to The Memes. I asked myself if I had made any absolute statements about The Memes.</p><p>I concluded that I had made two:</p><ul><li>that they would be CC0</li><li>that card #4 would be the lowest edition count</li></ul><p>So what should we do?</p></Col></Row>;
    $[28] = t28;
  } else {
    t28 = $[28];
  }
  let t29;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <Row className="pt-3"><Col><p className="font-larger font-bolder">Maintaining the Commitment</p><p>I decided that the correct answer is that those two absolutes never change.</p><p>That literally everything else might change, but that those two do not change.</p><p>The naive view is this is about my personal credibility.</p><p>I think it is actually much subtler than that.</p></Col></Row>;
    $[29] = t29;
  } else {
    t29 = $[29];
  }
  let t30;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <Row className="pt-3"><Col><p>It is about a group of people (not just me but the artists and collectors) agreeing about a hierarchy of decision-making.</p><p>No decision is free. Every choice has costs.</p><p>Societies coalesce by consensus on which ideals and absolutes they will sacrifice for.</p></Col></Row>;
    $[30] = t30;
  } else {
    t30 = $[30];
  }
  let t31;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <Row className="pt-3"><Col><p>Isn't this a totally absurd arbitrary number? Of course it is!</p><p>So is 21 million BTC. 21M BTC does not mean anything. It is an idea, it is a myth, it is a meme. It could be 10M or 100M.</p><p>What matters is ONLY if team BTC sticks to it, that is the magic about it.</p></Col></Row>;
    $[31] = t31;
  } else {
    t31 = $[31];
  }
  let t32;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <Row className="pt-3"><Col><p className="font-larger font-bolder">Managing Tradeoffs</p><p>BTC sacrifices many many other things to 21M and its other ideal (small blocks for decentralization).</p><p>There are tradeoffs. This is the necessary element for BTC being BTC.</p><p>Other chains make other tradeoffs which is also correct - we should try many things.</p></Col></Row>;
    $[32] = t32;
  } else {
    t32 = $[32];
  }
  let t33;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <Row className="pt-3"><Col><p>So BTC has 21M and small blocks. The Memes have the Nakamoto Threshold and CC0.</p><p>Before people get upset, obviously The Memes are not BTC.</p><p>But the social construction process is the same. You have to decide what you will sacrifice for.</p></Col></Row>;
    $[33] = t33;
  } else {
    t33 = $[33];
  }
  let t34;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <Row className="pt-3"><Col><p className="font-larger font-bolder">Implementation Pathways</p><p>Once this decision was made, we go to step 2: "how do we implement staying above 300 edition size".</p><p>The first idea "mint fewer times a week" is not a solution at all because it just skips the problem altogether.</p><p>What if you mint 1x a week and still a card fails to hit 300?</p></Col></Row>;
    $[34] = t34;
  } else {
    t34 = $[34];
  }
  let t35;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <Row className="pt-3"><Col><p>The second idea: "airdrop to collectors" is superficially a nice idea but, one thing I have learned, is that small partial airdrops are a net negative for collector happiness.</p><p>What do I mean? if @6529er airdrops a card to 2K top collectors = ok-ish.</p></Col></Row>;
    $[35] = t35;
  } else {
    t35 = $[35];
  }
  let t36;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <Row className="pt-3"><Col><p>But here the airdrops would be small - maybe 10 one week, maybe 50 another week, so any airdrop would leave out 99% of The Memes collectors.</p><p>Even if we used the 'fairest' possible formula in the world for allocating the airdrops (there is no perfectly fair formula).</p></Col></Row>;
    $[36] = t36;
  } else {
    t36 = $[36];
  }
  let t37;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <Row className="pt-3"><Col><p>I am 100% sure that:</p><ul><li>✅ the happiness of 10-20-30 collectors getting a 0.06529 ETH free airdrop of a card they might have not even wanted</li><li>...would be much less than...</li><li>✅ the annoyance of the other 9,500 who did not get it.</li></ul></Col></Row>;
    $[37] = t37;
  } else {
    t37 = $[37];
  }
  let t38;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <Row className="pt-3"><Col><p>And, in practice, what it would mean that several times a week we would be having endless cringe discussions of "if the airdrop formula was 'fair'".</p><p>Life is short and I do not intend to spend my life arguing about the formula for 0.5 ETH or 1ETH or 2ETH of airdrops.</p></Col></Row>;
    $[38] = t38;
  } else {
    t38 = $[38];
  }
  let t39;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <Row className="pt-3"><Col><p className="font-larger font-bolder">Decision Time</p><p>So time was running out, I was watching a card that would not mint out.</p><p>I decided to do the only thing 100% under my control and also that did not break the absolute rules.</p><p>I minted it myself over the 300 Nakamoto Threshold.</p></Col></Row>;
    $[39] = t39;
  } else {
    t39 = $[39];
  }
  let t40;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = <Row className="pt-3"><Col><p>And then it happened again, so I minted again.</p><p>And this went on for a while and tied up quite a bit of ETH that I had other plans for.</p><p>But my arbitrary rule, when there is no other solution, no better solution, I need to pay the price.</p></Col></Row>;
    $[40] = t40;
  } else {
    t40 = $[40];
  }
  let t41;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <Row className="pt-3"><Col><p className="font-larger font-bolder">Count the Costs</p><p>Now what are the costs (beyond ETH)? Some say it is cringe to mint your own drops.</p><p>OK, they are free to have their opinion. I do not think it is cringe. I am doing it openly. I like Meme Cards.</p><p>But even if some people don't like it, it goes in the 'sacrifice' bucket.</p></Col></Row>;
    $[41] = t41;
  } else {
    t41 = $[41];
  }
  let t42;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <Row className="pt-3"><Col><p>Another cost is concentration of ownership of a specific Meme Card.</p><p>This is true but the Meme Cards are the Lebron James of distributed ownership. It is only bad relative to other Meme Cards.</p><p>Vs everyone else, we are uber-chads here.</p></Col></Row>;
    $[42] = t42;
  } else {
    t42 = $[42];
  }
  let t43;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <Row className="pt-3"><Col><p>Many meme cards have unique ownership in the 80s-90%. The ones that I had to mint are generally 60-80%.</p><p>These are all laughably high numbers. Rare Pepes are worse, as punks, ABC, even XCOPY 1/1s. We have tons of room here to spare.</p></Col></Row>;
    $[43] = t43;
  } else {
    t43 = $[43];
  }
  let t44;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <Row className="pt-3"><Col><p>The reasons we are so good on distributed ownership is that we are obsessed with anti-sybil measures for reasons we will discuss later.</p><p>So this sacrifice was an easy one to take. Some Meme Cards are A+ on unique ownership. Some are B. It is totally fine.</p></Col></Row>;
    $[44] = t44;
  } else {
    t44 = $[44];
  }
  let t45;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = <Row className="pt-3"><Col><p className="font-larger font-bolder">Bigger Plans</p><p>Now, along the way, I was still thinking about what the long-term solution could be.</p><p>If you really believe in a long-term view for The Memes, me minting them out is a stopgap.</p><p>What if I run out of ETH? What if I am lost on a Nepalese hiking expedition?</p></Col></Row>;
    $[45] = t45;
  } else {
    t45 = $[45];
  }
  let t46;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <Row className="pt-3"><Col><p>What we decided is that in SZN7, at the end of the public phase, any cards needed to push edition size to 310 are airdropped to: research.6529.eth</p><p>This is an account that will work in the context of the tools we are building to support expertise on topics we need to study.</p></Col></Row>;
    $[46] = t46;
  } else {
    t46 = $[46];
  }
  let t47;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = <Row className="pt-3"><Col><p>Specifically this account will accrue some weight within the ecosystem but will use that weight only by proxy to bring in experts on various topics we are trying to solve—technical topics, legal topics, etc.</p><p>In other words, exactly what the name says "research".</p></Col></Row>;
    $[47] = t47;
  } else {
    t47 = $[47];
  }
  let t48;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = <Row className="pt-3"><Col><p className="font-larger font-bolder">Research What?</p><p>"Wait, what research does an art edition collection need?" Imagine thinking that is the goal.</p><p>Where we are going, we will need our own NSF, NIH, ERC, Horizon.</p><p>We don't need them now, but we will. So we can start planting the seeds now, let them grow.</p></Col></Row>;
    $[48] = t48;
  } else {
    t48 = $[48];
  }
  let t49;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t49 = <p className="font-larger font-bolder">Evaluating the Outcome</p>;
    $[49] = t49;
  } else {
    t49 = $[49];
  }
  let t50;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = <Row className="pt-3"><Col>{t49}<p>I am very happy with this solution.<ul><li>✅ It correctly establishes a hierarchy of priorities, of absolutes.</li><li>✅ It removes dependency on me.</li><li>✅ It plants a seed for the future.</li><li>✅ No real negatives.</li><li>✅ It is aesthetically extremely pleasing.</li></ul></p><p /></Col></Row>;
    $[50] = t50;
  } else {
    t50 = $[50];
  }
  let t51;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = <Row className="pt-3"><Col><p>I am also very happy with the process.<ul><li>✅ it took several months to get here, to figure this out.</li><li>✅ In the interim, I had to decide what to do and I took the decision to mint out until we find a good permanent solution.</li><li>✅ Group discussion was very good faith and civilized.</li></ul></p></Col></Row>;
    $[51] = t51;
  } else {
    t51 = $[51];
  }
  let t52;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = <Row className="pt-3"><Col><p className="font-larger font-bolder">Good Decision Making is Hard</p><p>Someone in Discord told me I "overthink" things and I laughed. This is literally my defining characteristic.</p><p>Excellent decisions are hard, they need, in fact, a lot of thinking, ideally with good group discussion, sometimes for months and years.</p></Col></Row>;
    $[52] = t52;
  } else {
    t52 = $[52];
  }
  let t53;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = <Row className="pt-3"><Col><p>Building a group culture that can make good decisions is the only thing that matters in the long-run. We will have endless opportunities and challenges.</p><p>There is no more higher leverage capability than being able to make good collective decisions. It is "all the alpha".</p></Col></Row>;
    $[53] = t53;
  } else {
    t53 = $[53];
  }
  let t54;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t54 = <Row className="pt-3"><Col><p className="font-larger font-bolder">Stacking Goods</p><p>Coming back to the aesthetically pleasing part, what is currently happening in The Memes is pure utter magic of stacking public goods on top of public goods on top of public goods.</p><p>All completely voluntary, all culturally driven, not contractually driven. It goes like this.</p></Col></Row>;
    $[54] = t54;
  } else {
    t54 = $[54];
  }
  let t55;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = <Row className="pt-3"><Col><p>This is the cycle:</p><p><ul><li>✅ Collectors mint incredible art from great artists, beautifully curated.</li><li>✅ Art enters the public domain.</li><li>✅ We (voluntarily) build software also in the public domain.</li><li>✅ Sometimes, the art will support science.</li><li>✅ [Redacted] A 4th public good we will show soon.</li></ul></p></Col></Row>;
    $[55] = t55;
  } else {
    t55 = $[55];
  }
  let t56;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t56 = <Container>{t0}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}{t19}{t20}{t21}{t22}{t23}{t27}{t28}{t29}{t30}{t31}{t32}{t33}{t34}{t35}{t36}{t37}{t38}{t39}{t40}{t41}{t42}{t43}{t44}{t45}{t46}{t47}{t48}{t50}{t51}{t52}{t53}{t54}{t55}<Row className="pt-3"><Col><p>Was lowering the mint cost an option at all?</p><p>This is an independent question. You could pick a lower price and still not mint out so you still have to resolve the absolute question head-on.</p><p>Mint price is not a system absolute like Nakamoto Threshold. In principle, it can change in the future.</p></Col></Row></Container>;
    $[56] = t56;
  } else {
    t56 = $[56];
  }
  return t56;
}